import React, { useEffect, useState } from "react";
import DashboardMenu from "../component/section/DashboardMenu";
import DashboardHeader from "../component/section/DashboardHeader";
import { Link } from "react-router-dom";
import StripeSubscription from "../component/payment/StripeSubscription";
import Spinner from "react-bootstrap/Spinner";
import matrimonyInstance from "../utils/axios";
import { getDataFromJwt, replaceIdInUrl } from "../utils/utility";
import { LIST_MY_PROFILES } from "../API_LIST";

const ProfilePage = () => {
  const [paymentClicked, setPaymentClicked] = useState(false);

  const enablePayment = () => {
    if (paymentClicked) {
      setPaymentClicked(false);
    } else {
      setPaymentClicked(true);
    }
  };

  const [userDetails, setUserDetails] = useState();
  const userId = getDataFromJwt("id");

  useEffect(() => {
    let userId = getDataFromJwt("id");
    let url = replaceIdInUrl(LIST_MY_PROFILES, userId);
    matrimonyInstance.get(url).then((response) => {
      let objectIs = response.data;
      setUserDetails(objectIs);
    });
  }, []);

  return (
    <React.Fragment>
      {userDetails ? (
        <div className="dashboard-content">
          <div className="view-profile-card-group">
            <Link to="/dashboard/edit-profile" className="profile-edit-icon">
              <img src="../assets/images/bat-img/profile-edit.svg" />
            </Link>
            <div className="view-profile-card mb-30">
              <h5>Profile Details</h5>
              <p>
                <span className="key mr-10">FirstName:</span>
                <span>{userDetails?.first_name}</span>
              </p>
              <p>
                <span className="key mr-10">LastName:</span>
                <span>{userDetails?.last_name}</span>
              </p>
              <p>
                <span className="key mr-10">Gender:</span>
                <span>{userDetails?.gender}</span>
              </p>
              <p>
                <span className="key mr-10">Date of Birth:</span>
                <span>{userDetails?.date_of_birth}</span>
              </p>
            </div>
            {/* <div className="profile-datails-card mb-30">
                <div className="payment-container">
                  <div className="card-wrapper text-left">
                    <div className="card-title">Register Account</div>
                    <div className="card-content">50$</div>
                  </div>
                  <div className="lets-connect">
                    <button
                      className="button login-btn"
                      onClick={enablePayment}>
                      {paymentClicked ? "Cancel Payment" : "Proceed To Payment"}
                    </button>
                  </div>
                  {paymentClicked && <StripeSubscription />}
                </div>
              </div> */}
          </div>
        </div>
      ) : (
        <p>Create a new profile to continue...</p>
      )}
    </React.Fragment>
  );
};

export default ProfilePage;
